/**
 * Created by Ning Jiang on 2024-02-01.
 */

import {DeadwoodRipStackedSymbol} from "./DeadwoodRipStackedSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {TimelineLite} from "gsap";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DeadwoodRip} from "../DeadwoodRip";
import {DeadwoodRipLayers, Layers} from "../view/DeadwoodRipLayers";
import {DeadwoodRipReelView} from "../reels/DeadwoodRipReelView";
import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipBackground} from "../view/DeadwoodRipBackground";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class DeadwoodRipS2Symbol extends DeadwoodRipStackedSymbol {
    private _overlay:PIXI.Sprite;

    constructor(symbolName:string, reelId:number, initState:DeadwoodRipSymbolState) {
        super(symbolName, reelId, initState);
        this._overlay = new PIXI.Sprite(ImgLoader.getImgTexture("S2_overlay"));
        this._overlay.name = "S2Overlay";
        this._overlay.anchor.set(0.5,0.75);
        this.addChild(this._overlay);
    }

    protected updateLayers():void {
        super.updateLayers();
        if (this._overlay){
            this.addChild(this._overlay);
        }
    }

    public playLanding(init:boolean = false):TimelineLite {
        this.createDeadContainer();
        const glow = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("S2"));
        glow.autoUpdate = true;
        glow.position.set(DeadwoodRipReelView.REEL_AREAS[4].x, DeadwoodRipReelView.REEL_AREAS[4].y + DeadwoodRipSymbol.DEFAULT_HEIGHT);
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(1, "S2Landing", false);
                DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(glow);
                glow.state.setAnimation(0, "s2Glow", false);
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S2_LAND});
                DeadwoodRipBackground.shakeStageOnce(0.3);
            }
        ]);
        tl.add(() => {
            DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!.removeChild(glow);
            glow.state.setEmptyAnimations(0);
            glow.destroy();
        }, `+=${this._deadCharacter.spineData.findAnimation("S2Landing").duration}`);
        return tl;
    }

    public playOnShot():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            Logger.logDev(`I am ${this._itemName}, I play on shot!`);
        });
        return tl;
    }

    protected getOnShotAnimationName():string {
        return "S2_Shoot";
    }

    protected getIndividualAnimationName():string {
        return `S2Toggle`;
    }

    protected getCharacterAssetName():string {
        return "S2";
    }

    public split(type:number, noWin:boolean):TimelineLite {
        const tl = new TimelineLite();
        this.createDeadContainer();
        if(noWin) {
            tl.add(() => {
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(1, "S2SplitNoWin", false);
            });
            tl.add(() => {
            }, `+=${this._deadCharacter.spineData.findAnimation("S2SplitNoWin").duration}`);
        } else {
            tl.add(() => {
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(1, "S2Split", false);
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S2_SPLIT_PIG});
            });
            tl.add(() => {
                this._deadCharacter.state.setAnimation(1, "S2Split", false).trackTime = this._deadCharacter.spineData.findAnimation("S2Split").duration;
            }, `+=${this._deadCharacter.spineData.findAnimation("S2Split").duration}`);
        }
        return tl;
    }

    public playWinSuper():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            const entry = this._deadCharacter.state.setAnimation(1, "S2UpdateFS", false);
            entry.timeScale = 0.5;
        });
        tl.add(() => {
            this._deadCharacter.state.setAnimation(1, "S2UpdateFS", false).time = this._deadCharacter.spineData.findAnimation("S2UpdateFS").duration;
        }, `+=${this._deadCharacter.spineData.findAnimation("S2UpdateFS").duration * 2}`);
        return tl;
    }

    public resetSuperFS():void {
        this.createDeadContainer();
        this._deadCharacter.visible = true;
        this._deadCharacter.state.setAnimation(1, "S2PigIdle", true);
        this._shootContainer.children.length = 0;
    }

    protected playKillSound():void {
        DeadwoodRipSound.playSymbolKill("S", this.reelId);
    }
}